import voucherFormRequest from './voucherFormModel';

export default class VoucherForm {
	constructor() {
		this.parentContainer = document.getElementById('orderSummary');
		this.voucherAction();
	}

	voucherAction() {
		this.parentContainer?.addEventListener('click', e => {
			if (e.target.closest('#voucherSubmit')) {
				e.preventDefault();
				this.voucherAdd();
			} else if (e.target.closest('#removeVoucher')) {
				e.preventDefault();
				this.voucherRemove();
			}
		});
	}

	voucherAdd() {
		const voucherCode = this.voucherToUpperCase();
		const url = '/ajax/voucher/apply-voucher';

		if (!voucherCode.length) return null;
		return this.voucherCallAPI(voucherCode, url);
	}

	voucherRemove() {
		const voucherCode = document
			.getElementById('removeVoucher')
			.getAttribute('data-voucher-code');
		const url = '/ajax/voucher/remove-voucher';

		return this.voucherCallAPI(voucherCode, url);
	}

	voucherCallAPI(voucherCode, url) {
		const voucherSubmitBtn = document.getElementById('voucherSubmit');
		if (voucherSubmitBtn) {
			voucherSubmitBtn.disabled = true;
		}

		return voucherFormRequest({ voucherCode }, url).then(({ data }) => {
			document.getElementById('checkoutSummarySectionContent').innerHTML = data;
		});
	}

	voucherToUpperCase() {
		const voucherInput = document.getElementById('voucherCode');
		return voucherInput.value.trim().toUpperCase();
	}
}
